import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; 

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }) {
    const { auth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    

    useEffect(() => {
        const token = localStorage.getItem(`authToken`);
        // Якщо немає авториазціх і не існує токен - редірект на логін
        if ((!auth?.isLogin) && (!token)) {
            navigate('/login', {
                state: {
                    from: location.pathname
                },
                replace: true
            });
        }
    }, [auth, navigate, location]); 

    return children;
    
} 

AuthGuard.propTypes = { children: PropTypes.any };
